import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class WorkflowService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/workflows`);
  }

  snapshot(urlParams: any = {}) {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/workflows/snapshot`, urlParams);
    return this.http.post(url, {});
  }
}
